export const API_BASE_URL = 'https://api.lakewanaka.co.nz';
export const ALLOW_EVENT_SUBMIT = true;

export const MAP_DEFAULT_CENTER = [-44.6941691, 169.1364637];